import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { UrlPagos } from '../../config';

const Cobranzas = ({ user }) => {
  const iframeRef = useRef();

  const sendUserToIframe = () => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow && user?.id) {
      iframe.contentWindow.postMessage(
        { tipo: 'user', payload: user },
        '*' // Podés poner el dominio exacto si querés seguridad
      );
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { tipo } = event.data || {};
      if (tipo === 'pedirUsuario') {
        console.log('🧩 Iframe pidió el usuario, enviando...');
        sendUserToIframe();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [user?.id]); // Se vuelve a registrar si cambia el ID del usuario

  return (
    <Container>
      <LinkPay
        ref={iframeRef}
        allow="clipboard-write"
        src={UrlPagos}
        title="Pagos iframe"
      />
    </Container>
  );
};

export default Cobranzas;
// Estilos
const Container = styled.div`
  width: 100%;
  height: calc(100vh - 100px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  justify-content: flex-start;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
`;

const LinkPay = styled.iframe`
  width: 100%;
  height: calc(100vh - 100px);
  border: none;
`;
